import React from "react";

export const RedWords = ({ prop }) => {
    return <span className="section__lead_color">{prop}</span>;
};